import { HubConnectionBuilder, HubConnectionState } from "@microsoft/signalr";
import store from '@/store'
import { ensureLocationInNubmer } from "@/utils/map/mapUtils";

const actionName = "getVehicleExtraDetails";

const connection = new HubConnectionBuilder()
// https://api.testtracker.xyz/coregps/SignalHub/"
//https://apiv2.trackervigil.com/coregps/SignalHub/
    .withUrl("https://api.testtracker.xyz/coregps/SignalHub/", {
        // .withUrl("http://localhost:5000/shapeHub/", {
        // skipNegotiation: true,
        // transport: HttpTransportType.WebSockets
    })
    .withAutomaticReconnect()
    .build();

connection.onclose(function () {
    console.warn("SignalR Disconnected");
    setTimeout(function () {
        start();
    }, 5000); // Restart connection after 5 seconds.
});

connection.onreconnecting(error => {
    console.log("#statuslog",connection.state)
    console.assert(connection.state === HubConnectionState.Reconnecting);
    console.warn(`Connection lost due to error "${error}". Reconnecting.`);
    
});

connection.onreconnected(() => {
    console.log('RECONNECTED ... ', getConnectionStatus());
    const vehicles = store.getters["getVehicleDeviceIdList"];
    const ids = vehicles.map(v => v.imei);
    setLiveTrackingDataListener(actionName);
    subscribe(ids).then((data) => {
        console.log('SUBSCRIBED', data);
    }).catch(err => {
        console.log('Error while Subscribing', err);
    });
});

export const getConnectionStatus = () => connection.state;

export const start = async function () {
    try {
        console.log('Connection is ', connection.state);
        if (connection.state === HubConnectionState.Disconnected) {
            store.dispatch("updateMapConnectionStatus",connection.state);
            await connection.start();
            store.dispatch("updateMapConnectionStatus",connection.state);
        }
    } catch (error) {
        console.error(`Connection Error due to "${error}".`);
        setTimeout(function () {
            start()
        }, 5000);
    }
}

export const setLiveTrackingDataListener = function (action = actionName) {
    connection.on("getLiveTrackingData", function (data) {

        store.dispatch(action, ensureLocationInNubmer(data));
    });
}

export const subscribe = async function (ids) {
    const deviceData = { connectionId: "0", Device_Imei: ids };
    console.log('#SUBSCRIBED', ids);
    await connection.invoke("Subscribe", deviceData);
}

export const stop = async function () {
    console.warn('Stopping Connections');
    connection.off("Subscribe");
    await connection.stop();
}
